import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';

export default function FormHeader({ align, messaging }) {
  const { header, copy } = messaging;

  return (
    <Align type={align}>
      {header}
      {copy}
    </Align>
  );
}

FormHeader.propTypes = {
  align: PropTypes.string.isRequired,
  messaging: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/FormHeader/index.js